import { render, staticRenderFns } from "./history-no-sign.vue?vue&type=template&id=a270088a&"
import script from "./history-no-sign.vue?vue&type=script&lang=ts&"
export * from "./history-no-sign.vue?vue&type=script&lang=ts&"
import style0 from "./history-no-sign.vue?vue&type=style&index=0&id=a270088a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports